export default __webpack_public_path__ + "media/Leadership.feadb29f.svg";